import * as React from "react";
import { useContext } from "react";
import { EditProjectContext } from "../../../EditProjectContext";
import { isProjectReadOnly } from "../../../IsProjectReadOnly";
import { updateRoutePropertyOnProject } from "./UpdateRoutePropertyOnProject";
import { DropDownList } from "../../../../../Layout/Inputs/DropDownList";
import { RouteNumberAreaInputProps } from "./RouteNumberAreaInputProps";

export const ContainerType = ({ route, disabled = false }: RouteNumberAreaInputProps) => {
  const projectContextProps = useContext(EditProjectContext);
  const { project } = projectContextProps;

  const list = [
    { text: "-", value: "-" },
    { text: "EB121097/EB121060(F)", value: "EB121097/EB121060(F)" },
    { text: "EB121097/EB121060(F+U)", value: "EB121097/EB121060(F+U)" },
    { text: "EB121097/EB121060(U)", value: "EB121097/EB121060(U)" },
    { text: "FLC1210/FSC1206 (F)", value: "FLC1210/FSC1206 (F)" },
    { text: "FLC1210/FSC1206 (F+U)", value: "FLC1210/FSC1206 (F+U)" },
    { text: "FLC1210/FSC1206 (U)", value: "FLC1210/FSC1206 (U)" },
    { text: "FoP-SoP", value: "FoP-SoP" },
    { text: "FXC + EB", value: "FXC + EB" },
    { text: "FXC + OD", value: "FXC + OD" },
    { text: "FXC + OD + EB", value: "FXC + OD + EB" },
    { text: "OD + EB", value: "OD + EB" },
    { text: "OD8401/OD8402", value: "OD8401/OD8402" },
    { text: "Other", value: "Other" },
  ];

  return (
    <DropDownList
      label="Container Type"
      list={list}
      value={route.ContainerType}
      onChange={(value) => {
        updateRoutePropertyOnProject(
          "ContainerType",
          value,
          route.RouteNumber || "",
          projectContextProps
        );
      }}
      disabled={isProjectReadOnly(project) || disabled}
    />
  );
};
